import React from "react";
import { makeStyles } from "@mui/styles";
import { Backdrop, Typography } from "@mui/material";
import Lottie from "lottie-react";
import loaderAnimation from "../../assets/lottie/Loading.json";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    display: "flex",
    position: "fixed",
    alignItems: "center",
    justifyContent: "center",
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  card: {
    width: "50%",
    maxWidth: "400px",
    height: "auto",
    display: "flex",
    textAlign: "center",
    borderRadius: "8px",
    alignItems: "center",
    flexDirection: "column",
    backgroundColor: "#fff",
    padding: theme.spacing(4),
    justifyContent: "center",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(3),
    },
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(2),
    },
  },
  spinner: {
    width: "90%",
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("xs")]: {
      width: "60%",
    },
    [theme.breakpoints.down("sm")]: {
      width: "50%",
    },
    [theme.breakpoints.down("md")]: {
      width: "50%",
    },
    [theme.breakpoints.up("lg")]: {
      width: "50%",
    },
  },
  text: {
    fontSize: 18,
    fontWeight: "bold",
    color: "black",
    fontFamily: '"Poppins", serif',
    [theme.breakpoints.down("xs")]: {
      fontSize: 16,
      fontWeight: "bold",
      color: "black",
    },
  },
}));

const LoadingSpinner = ({ open }) => {
  const classes = useStyles();

  return (
    <Backdrop className={classes.backdrop} open={open}>
      <div className={classes.card}>
        <Lottie
          animationData={loaderAnimation}
          loop={true}
          autoplay={true}
          className={classes.spinner}
        />
        <Typography fontWeight={"bold"} className={classes.text}>
          Loading... Please wait
        </Typography>
      </div>
    </Backdrop>
  );
};

export default LoadingSpinner;
